import { GetServerSideProps } from "next"
import { useEffect, useState } from "react"
import EcomFormBoxApp from "../../components/EcomFormBoxApp/index"
import EcomMenu from "../../components/EcomMenu"
import Footer from "../../components/Footer"
import styles from "../styles.module.scss"
import componentStyles from "./style.module.scss"

import { useRouter } from "next/router"
import StoryBlokService from "../../services/StoryBlokService"
import Error500Component from "../error/500"
import { useSessionStorage, useTaggingGa4 } from "../../hooks"

const Main = ({ data, error }) => {
  const { query } = useRouter()
  const [isMobile, setIsMobile] = useState(true)
  const [isDesktop, setIsDesktop] = useState(false)
  const [storyBlokConfig, setStoryBlokConfig] = useState<unknown>()
  const [webviewMode, setWebviewMode] = useState(true)
  const { pushCommonDataLayer } = useTaggingGa4()

  useEffect(() => {
    pushCommonDataLayer("view_porteira", {
      custom_section: "planos-claro-res:geral",
      custom_title: "porteira_tv"
    })
  }, [])

  useEffect(() => {
    Object.keys(query).forEach((key) => {
      if (key === "id") return

      sessionStorage.setItem(key, query?.[key] as string)
    })

    history.pushState({}, "", `/cobertura/${query.id}`)
    const handleBackButtonEvent = (e) => {
      e.preventDefault()
      sessionStorage.clear()
    }
    window.addEventListener("popstate", handleBackButtonEvent)
    return () => {
      window.removeEventListener("popstate", handleBackButtonEvent)
    }
  }, [])

  useEffect(() => {
    const updateMedia = () => {
      setIsMobile(window.innerWidth <= 800)
      setIsDesktop(window.innerWidth > 800)
    }
    updateMedia()
    window.addEventListener("resize", updateMedia)
    return () => window.removeEventListener("resize", updateMedia)
  })

  useEffect(() => {
    ;(async () => {
      try {
        const response = await StoryBlokService.getConfig("regras-gerais")
        setStoryBlokConfig(response)
      } catch (error) {
        console.error("Erro ao obter dados:", error)
      }
    })()
  }, [])

  const dataParse = {
    imgMobile: data?.story?.content?.bannerMobile?.filename,
    imgDesktop: data?.story?.content?.bannerDesktop?.filename
  }

  useEffect(() => {
    const product = {
      id: data?.story?.content?.productId,
      name: data?.story?.content?.productName
    }
    sessionStorage.setItem(`${query.id}-product`, JSON.stringify(product))
  }, [data])

  useEffect(() => {
    const sessionWebview = sessionStorage.getItem("webview")

    setWebviewMode(sessionWebview === "true")
  }, [])

  if (error.status === 404 || error.status === 500) return <Error500Component />

  return (
    <div className={styles.pageWrapper}>
      {!webviewMode && (
        <header>
          <EcomMenu storyBlok={storyBlokConfig} />
        </header>
      )}

      {isMobile && (
        <main id="main-content">
          <div className={`${componentStyles.height100}`}>
            <div
              className={`${componentStyles.mobileBanner}`}
              style={{
                backgroundImage: `url(${dataParse.imgMobile})`
              }}
            />
            <div className={`mdn-Col-lg-6 ${componentStyles.noMargin}`}>
              <div className={`${componentStyles.mobileCard}`}>
                <div className={`mdn-Row ${styles.container}`}>
                  <div className="mdn-Col-xs-12">
                    <h1
                      className={`mdn-Heading mdn-Heading--sm mdn-Heading ${styles.bannerHeading}`}
                    >
                      Informe seus dados para prosseguir
                    </h1>
                    <p className={`mdn-Text mdn-Text--body ${styles.bodyText}`}>
                      Campos obrigatórios.
                    </p>
                  </div>
                </div>
                {/* Snippet start */}
                <div className={`mdn-Row ${styles.container}`}>
                  <div
                    className={`mdn-Alert mdn-Alert--success mdn-Alert--light mdn-isOpen ${componentStyles.alertDadosIncorretos}`}
                  >
                    <div className="mdn-Tag mdn-Tag--feedback">
                      <div
                        className={`mdn-Alert-content ${componentStyles.mdnAlertContentAlertDadosIncorretos}`}
                      >
                        <em
                          className={`mdn-Tag-icon mdn-Icon-triangulo-exclamacao mdn-Icon--md ${componentStyles.mdnTagiconalertDadosIncorretos}`}
                        ></em>
                        <p>
                          <b>Atenção!</b> Dados incorretos podem causar a recusa
                          do pedido.
                          <br />
                          Por favor, confirme que as informações inseridas,
                          correspondem à mesma pessoa vinculada ao CPF
                          informado, antes de continuar.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Snippet end */}
                <div className={`mdn-Row ${styles.container}`}>
                  <EcomFormBoxApp />
                </div>
              </div>
            </div>
          </div>
        </main>
      )}

      {isDesktop && (
        <main id="main-content">
          <div
            className={`mdn-Row ${componentStyles.height100} ${componentStyles.noMargin}`}
          >
            <div
              className={`mdn-Col-lg-6 fixed-height ${componentStyles.noPadding}`}
            >
              <div
                className={componentStyles.banner}
                style={{
                  backgroundImage: `url(${dataParse.imgDesktop})`
                }}
              />
            </div>
            <div className="mdn-Col-lg-6">
              <div className={styles.content}>
                <div className={`mdn-Row ${styles.container}`}>
                  <div className={`mdn-Col-xs-12 ${componentStyles.noPadding}`}>
                    <h1 className="mdn-Heading mdn-Heading--sm">
                      Informe seus dados para prosseguir
                    </h1>
                    <p className={`mdn-Text mdn-Text--body ${styles.bodyText}`}>
                      Campos obrigatórios.
                    </p>
                  </div>
                </div>
                <div className={`mdn-Row ${styles.container}`}>
                  <div className={`mdn-Col-xs-12 ${componentStyles.noPadding}`}>
                    {/* Snippet start */}
                    <div
                      className={`mdn-Alert mdn-Alert--success mdn-Alert--light mdn-isOpen ${componentStyles.alertDadosIncorretos}`}
                    >
                      <div className="mdn-Tag mdn-Tag--feedback">
                        <div
                          className={`mdn-Alert-content ${componentStyles.mdnAlertContentAlertDadosIncorretos}`}
                        >
                          <em
                            className={`mdn-Tag-icon mdn-Icon-triangulo-exclamacao mdn-Icon--md ${componentStyles.mdnTagiconalertDadosIncorretos}`}
                          ></em>
                          <p>
                            <b>Atenção!</b> Dados incorretos podem causar a
                            recusa do pedido.
                            <br />
                            Por favor, confirme que as informações inseridas,
                            correspondem à mesma pessoa vinculada ao CPF
                            informado, antes de continuar.
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* Snippet end */}
                  </div>
                </div>
                <div className={`mdn-Row ${styles.container}`}>
                  <EcomFormBoxApp />
                </div>
              </div>
            </div>
          </div>
        </main>
      )}

      {!webviewMode && (
        <footer>
          <Footer storyBlok={storyBlokConfig} />
        </footer>
      )}
    </div>
  )
}

type TStoryBlokEnvProps = {
  api: string
  token: string
  version: string
  cv: string
}

const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const env = process.env.storyBlokApi as unknown as TStoryBlokEnvProps
  const url = `${env.api}/residencial/prospect/porteira-adaptada/${query.id}?version=${env.version}&token=${env.token}&cv=${env.cv}`
  try {
    const response = await fetch(url)
    const data = await response.json()
    if (response.status !== 200) {
      throw {
        status: response.status
      }
    }

    return {
      props: {
        data,
        error: response.status
      }
    }
  } catch (err) {
    console.error(err)
    return {
      props: {
        data: null,
        error: err
      }
    }
  }
}

export { getServerSideProps }
export default Main
